export const getRuntimeReadiness = ({ transport, env }) => {
  if (transport === 'mock') {
    return { ready: true, mode: 'mock', issues: [] };
  }
  const issues = [];
  if (!env.REACT_APP_API_KEY) issues.push('Parse application ID is missing.');
  if (!env.REACT_APP_SERVER_LOCAL && !env.REACT_APP_API_URL) {
    issues.push('Parse server URL is missing.');
  }
  return {
    ready: issues.length === 0,
    mode: 'parse',
    issues,
  };
};

export const runtimeReadiness = getRuntimeReadiness({
  transport: process.env.REACT_APP_API_TRANSPORT === 'parse' ? 'parse' : 'mock',
  env: process.env,
});
